import React from 'react';

function PipelineBoard({
  pipelineData, selectedDeals, dragOverStage, formatCurrency, formatDate,
  onDragStart, onDragEnd, onDragOver, onDrop, onViewDeal,
  onToggleDealSelection, onSelectAllInStage, setDragOverStage
}) {
  return (
    <div className="pipeline-board">
      {pipelineData.map(stage => (
        <div
          key={stage.id}
          className={`pipeline-column ${dragOverStage === stage.id ? 'drag-over' : ''}`}
          onDragOver={(e) => onDragOver(e, stage.id)}
          onDragLeave={() => setDragOverStage(null)}
          onDrop={(e) => onDrop(e, stage.id)}
        >
          <div className="column-header" style={{ borderTopColor: stage.color }}>
            <div className="column-header-top">
              <input
                type="checkbox"
                className="column-select-all"
                checked={stage.deals?.length > 0 && stage.deals.every(d => selectedDeals.includes(d.id))}
                onChange={() => onSelectAllInStage(stage.id)}
                title="Markera/avmarkera alla i kolumnen"
              />
              <h3>{stage.name}</h3>
            </div>
            <div className="column-stats">
              <span className="deal-count">{stage.dealCount || 0}</span>
              <span className="column-value">{formatCurrency(stage.totalValue)}</span>
            </div>
          </div>

          <div className="column-content">
            {stage.deals?.map(deal => (
              <div
                key={deal.id}
                className={`deal-card ${selectedDeals.includes(deal.id) ? 'selected' : ''}`}
                draggable
                onDragStart={(e) => onDragStart(e, deal)}
                onDragEnd={onDragEnd}
                onClick={() => onViewDeal(deal)}
              >
                <div className="deal-card-header">
                  <input
                    type="checkbox"
                    className="deal-checkbox"
                    checked={selectedDeals.includes(deal.id)}
                    onChange={(e) => onToggleDealSelection(deal.id, e)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div className="deal-header-text">
                    <span className="deal-name">{deal.name}</span>
                    {deal.company && <span className="deal-company">{deal.company.name}</span>}
                  </div>
                </div>
                <div className="deal-card-body">
                  <div className="deal-value">{formatCurrency(deal.expectedValue)}</div>
                  <div className="deal-meta">
                    <span className="deal-probability">{deal.probability}%</span>
                    {deal.expectedCloseDate && (
                      <span className="deal-date">{formatDate(deal.expectedCloseDate)}</span>
                    )}
                  </div>
                </div>
                {deal.assignedTo && (
                  <div className="deal-card-footer">
                    <span className="deal-assignee">
                      {deal.assignedTo.firstName} {deal.assignedTo.lastName?.charAt(0)}.
                    </span>
                  </div>
                )}
              </div>
            ))}

            {(!stage.deals || stage.deals.length === 0) && (
              <div className="empty-column">Dra hit för att flytta</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PipelineBoard;
